import React, { useState, useEffect, useRef } from "react";
import style from "./HealthStatus.module.scss";
import { Cross, Pencil, Tick } from "../../../modules/default-svg";
import TextArea from "../../../components/controls/textarea/Textarea";
import FillRing from "../../../components/controls/fillRing/FillRing";
import { constrainInput, getFillRatio, useReportFonts } from "../../../helpers/textFit";

// `layout` is one of the multi-line entries of REPORT_LAYOUTS: the width of the report cell the text is
// rendered in and how many wrapped rows it may occupy.
const HealthStatusTextField = ({ content = '', disabled = false, onChange, placeholder = '', title = '', layout }) => {
    const [readOnly, setReadonly] = useState(true);
    const [description, setDescription] = useState('');
    const containerRef = useRef(null);
    useReportFonts();

    useEffect(() => {
        if (readOnly === false) {
            setTimeout(() => {
                if (containerRef.current) {
                    const textarea = containerRef.current.querySelector('textarea');
                    if (textarea) {
                        textarea.focus();
                    }
                }
            }, 100);
        }
    }, [readOnly]);

    useEffect(() => {
        setDescription(content || '');
    }, [content]);

    const handleDescription = (value) => {
        setDescription(prev => constrainInput(value, prev, layout));
    };

    const handleConfirm = () => {
        onChange(description);
        setReadonly(true);
    };

    const handleCancel = () => {
        setReadonly(true);
        setDescription(content || '');
    };

    return (
        <div className={`${style.itemCard} ${disabled ? style.disabledContainer : ''} mb-3`}>
            <div className={`${style.itemCardHeader} position-relative`}>
                <div className="d-flex justify-content-center mb-3">
                    <span className={`${style.periodLabelPill} ${style.kpiSectionPill}`}>{title}</span>
                </div>
                {readOnly && !disabled && (
                    <button
                        type="button"
                        className={`${style.editbtnstext} ${style.hoverVisible} position-absolute top-0 end-0`}
                        onClick={() => setReadonly(false)}
                    >
                        <Pencil />
                    </button>
                )}
            </div>
            <div className={style.itemCardBody}>
                <div ref={containerRef}>
                    <TextArea
                        textAreaFieldSize={style.itemCardBodyTextArea}
                        value={description}
                        onChange={(e) => handleDescription(e)}
                        placeholder={placeholder}
                        readonly={readOnly}
                        style={{ FontSize: "14px" }}
                        handleKeyDown={(e) => {
                            if (e.key === 'Enter' && e.ctrlKey) {
                                e.preventDefault();
                                handleConfirm();
                            }
                        }}
                    />
                </div>
                {!readOnly && (
                    <div className="d-flex align-items-center justify-content-between mt-2">
                        <div className="AvatarColor">
                            <FillRing ratio={getFillRatio(description, layout)} />
                        </div>
                        <div className="d-flex gap-2">
                            <button type="button" className="edit-btns" onClick={handleConfirm}>
                                <Tick />
                            </button>
                            <button type="button" className="edit-btns" onClick={handleCancel}>
                                <Cross />
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default HealthStatusTextField;
